import { render, staticRenderFns } from "./PaymentRecite.vue?vue&type=template&id=bc795798&scoped=true"
import script from "./PaymentRecite.vue?vue&type=script&lang=js"
export * from "./PaymentRecite.vue?vue&type=script&lang=js"
import style0 from "./PaymentRecite.vue?vue&type=style&index=0&id=bc795798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc795798",
  null
  
)

export default component.exports